module.exports = __webpack_public_path__ + "static/laundromatslider-08-min-8868d3f4d836019ccd2b65448f50d560.jpg";